import { render, staticRenderFns } from "./ProfileProjects.vue?vue&type=template&id=35490616&"
import script from "./ProfileProjects.vue?vue&type=script&lang=js&"
export * from "./ProfileProjects.vue?vue&type=script&lang=js&"
import style0 from "./ProfileProjects.vue?vue&type=style&index=0&id=35490616&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports